// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dv-a";
export var fulfillmentFormRail = "_dv-9";
export var headerTitleRow = "_dv-c";
export var orderDetailsWrapper = "_dv-7";
export var orderLinkTrigger = "_dv-2";
export var paymentInformationGrid = "_dv-h";
export var paymentSummaryColumn = "_dv-i";
export var shipmentContainer = "_dv-b";
export var shipmentDetailsMainPane = "_dv-8";
export var shipmentNavigationCard = "_dv-5";
export var shipmentNavigationRail = "_dv-3";
export var shipmentNavigationRailHeader = "_dv-4";
export var shipmentSummaryFact = "_dv-e";
export var shipmentSummaryGrid = "_dv-d";
export var shipmentSummaryMetadataRow = "_dv-f";
export var shipmentSummaryTags = "_dv-g";
export var shipmentWorkspace = "_dv-0";
export var shipmentWorkspaceContent = "_dv-6";
export var shipmentWorkspaceHeader = "_dv-1";